

import Component from 'generic.basecomponent';
import $ from 'jquery';
import app from 'app-instance';
import pageSpinner from 'page-spinner';
import { TYPE_PRODUCT, TYPE_DONATION } from './basket-item-types';
import basketManager from './basket-manager';

export default class Basket extends Component {
    constructor(el) {
        super(el);
        this.removeItemUrl = '/api/shoppingcart/removeproduct';
        this.itemSelector = '.js-basket-item';
        this.itemRemoveSelector = '.js-basket-item-remove';
        this.itemQuantitySelector = '.js-basket-item-quantity';
        this.itemTotalSelector = '.js-basket-item-total';
        this.basketTotalSelector = '.js-basket-total';
        this.basketShippingSelector = '.js-basket-shipping';
        this.basketShippingDropdownSelector = '.js-basket-shipping-dropdown';

        this.onShippingChange = this.onShippingChange.bind(this);

        this.items = {};
        this.inProgress = false;
        this.modal = null;
        this.init();
    }

    init() {
        this.total = this.container.querySelector(this.basketTotalSelector);
        this.shipping = this.container.querySelector(this.basketShippingSelector);
        this.shippingDropdown = this.container.querySelector(this.basketShippingDropdownSelector);

        const items = [...this.container.querySelectorAll(this.itemSelector)];
        if (!items) {
            return;
        }


        items.forEach((item) => {
            const itemId = item.getAttribute('data-basket-item-id');
            if (itemId) {
                const remove = item.querySelector(this.itemRemoveSelector);
                const quantity = item.querySelector(this.itemQuantitySelector);
                const total = item.querySelector(this.itemTotalSelector);

                if (remove && quantity) {
                    remove.addEventListener('click', (e) => {
                        this.onRemoveClick(itemId, e);
                    });
                    quantity.addEventListener('change', (e) => {
                        this.onQuantityChange(itemId, e);
                    });

                    this.items[itemId] = {
                        item,
                        total,
                        type: quantity.getAttribute('data-basket-item-type') === 'donation' ? TYPE_DONATION : TYPE_PRODUCT,
                        quantity: this.getPreparedValue(quantity.value)
                    };
                }
            }
        });

        if (this.shippingDropdown) {
            this.shippingDropdown.addEventListener('change', this.onShippingChange);
        }
    }

    onRemoveClick(itemId, e) {
        if (!this.inProgress) {
            this.inProgress = true;
            this.container.classList.add('is-loading');
            return this.doRemoveItemRequest({ Id: itemId }).then((result) => {
                if (result.Result) {
                    this.removeItem(itemId);
                    this.updateBasket(result.ShoppingCart);
                } else {
                    basketManager.renderCartErrorMessage(result.Error);
                }
            }, (error) => {
                basketManager.proceedCartOperationError(error);
            }).then(() => {
                this.inProgress = false;
                this.container.classList.remove('is-loading');
            });
        }
    }

    onShippingChange(e) {
        const clientId = e.target.getAttribute('data-clientid');
        pageSpinner.show({ fade: true });
        window.__doPostBack(clientId, '');
    }

    removeItem(itemId) {
        const item = this.items[itemId].item;
        this.container.removeChild(item);
    }

    getPreparedValue(value) {
        return parseFloat(value);
    }

    onQuantityChange(itemId, e) {
        const input = e.target;
        const quantity = this.getPreparedValue(input.value);
        return this.validateItemQuantity(quantity).then(() => {
            if (!this.inProgress) {
                this.inProgress = true;
                this.container.classList.add('is-loading');
                return this.doUpdateQuantityRequest(this.getUpdateQuantityUrl(itemId), this.getUpdateQuantityBody(itemId, quantity)).then((result) => {
                    if (result.Result) {
                        this.updateItem(itemId, result.ShoppingCart);
                        this.commitItemQuantity(itemId, quantity);
                        this.updateBasket(result.ShoppingCart);
                    } else {
                        this.rollbackItemQuantity(itemId, input);
                        basketManager.renderCartErrorMessage(result.Error);
                    }
                }, (error) => {
                    this.rollbackItemQuantity(itemId, input);
                    basketManager.proceedCartOperationError(error);
                }).then(() => {
                    this.inProgress = false;
                    this.container.classList.remove('is-loading');
                });
            }
        }, () => {
            this.rollbackItemQuantity(itemId, input);
        });
    }

    getUpdateQuantityBody(itemId, quantity) {
        const param = this.items[itemId].type === TYPE_PRODUCT ? 'Quantity' : 'Amount';
        return {
            Id: itemId,
            [param]: quantity
        };
    }

    getUpdateQuantityUrl(itemId) {
        switch (this.items[itemId].type) {
            case TYPE_PRODUCT:
                return '/api/shoppingcart/updatequantity';
            case TYPE_DONATION:
                return '/api/shoppingcart/updatedonationamount';
        }
    }

    updateItem(itemId, basket) {
        const basketItem = basket.Items.find(item => item.Id === parseInt(itemId));
        if (basketItem) {
            this.items[itemId].total.innerHTML = basketItem.FormattedTotalPrice;
        }
    }

    doRemoveItemRequest(body, params = {}) {
        return new Promise((resolve, reject) => {
            $.ajax({
                method: 'delete',
                url: this.getUrl(this.removeItemUrl, params),
                data: body
            }).done((response) => {
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }

    doUpdateQuantityRequest(url, body, params = {}) {
        return new Promise((resolve, reject) => {
            $.ajax({
                method: 'post',
                url: this.getUrl(url, params),
                data: body
            }).done((response) => {
                resolve(response);
            }).fail((error) => {
                reject(error);
            });
        });
    }

    getUrl(url, params) {
        const paramsString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
        return `${url}` + (paramsString !== '' ? `?${paramsString}` : '');
    }

    updateBasket(basket) {
        this.total.innerHTML = basket.FormattedTotalPrice;
        this.shipping.innerHTML = basket.FormattedShippingPrice;
        app.emitEvent('basket', [basket]);
    }

    rollbackItemQuantity(itemId, input) {
        console.log(input.value);
        input.value = this.items[itemId].quantity;
        console.log(input.value);
    }

    commitItemQuantity(itemId, value) {
        this.items[itemId].quantity = value;
    }

    validateItemQuantity(value) {
        const result = !isNaN(value) && value > 0;
        return result ? Promise.resolve() : Promise.reject();
    }
}

Basket.id = 0;



// WEBPACK FOOTER //
// ./app/components/shop/js/generic.basket.js